import React from 'react';
import { site } from '../../data/site';
import { focusRing } from '../../utils/styles';
const icons = [{
  name: 'Facebook',
  href: site.social.facebook,
  path: 'M13.5 21v-7.5h2.5l.4-3h-2.9V8.6c0-.9.3-1.5 1.5-1.5h1.5V4.4c-.3 0-1.2-.1-2.2-.1-2.2 0-3.8 1.4-3.8 3.9v2.3H8v3h2.5V21h3z'
}, {
  name: 'Instagram',
  href: site.social.instagram,
  path: 'M12 7.3A4.7 4.7 0 1 0 12 16.7 4.7 4.7 0 0 0 12 7.3zm0 7.7a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm4.9-7.9a1.1 1.1 0 1 1-2.2 0 1.1 1.1 0 0 1 2.2 0zM20 8.1c-.1-1.5-.4-2.8-1.5-3.9S16.1 2.8 14.6 2.7C13.1 2.6 10.9 2.6 9.4 2.7 7.9 2.8 6.6 3.1 5.5 4.2S4.1 6.6 4 8.1c-.1 1.5-.1 6.3 0 7.8.1 1.5.4 2.8 1.5 3.9s2.4 1.4 3.9 1.5c1.5.1 6.3.1 7.8 0 1.5-.1 2.8-.4 3.9-1.5s1.4-2.4 1.5-3.9c.1-1.5.1-6.3 0-7.8zm-2 9.5a3 3 0 0 1-1.7 1.7c-1.2.5-3.9.4-5.2.4s-4 .1-5.2-.4a3 3 0 0 1-1.7-1.7c-.5-1.2-.4-3.9-.4-5.2s-.1-4 .4-5.2a3 3 0 0 1 1.7-1.7c1.2-.5 3.9-.4 5.2-.4s4-.1 5.2.4a3 3 0 0 1 1.7 1.7c.5 1.2.4 3.9.4 5.2s.1 4-.4 5.2z'
}, {
  name: 'LinkedIn',
  href: site.social.linkedin,
  path: 'M6.9 20H3.6V9.3h3.3V20zM5.2 7.8a1.9 1.9 0 1 1 0-3.8 1.9 1.9 0 0 1 0 3.8zM20.4 20h-3.3v-5.2c0-1.2 0-2.8-1.7-2.8s-2 1.3-2 2.7V20h-3.3V9.3h3.2v1.5h.1c.4-.8 1.5-1.7 3.1-1.7 3.3 0 3.9 2.2 3.9 5V20z'
}];
export function SocialIcons() {
  return <ul className="flex gap-3" data-id="element-207" data-mp="2joqb9lygq0l2">
      {icons.map(icon => <li key={icon.name} data-id="element-208" data-mp="2jq9spfvuuhof">
          <a href={icon.href} target="_blank" rel="noopener noreferrer" aria-label={`${icon.name} (opens in new tab)`} className={`flex h-11 w-11 items-center justify-center rounded-full border border-white/25 text-white transition-colors duration-150 ease-out hover:border-gold hover:bg-gold hover:text-brand-deeper ${focusRing}`} data-id="element-209" data-mp="2oo1rmtux3424">
            <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true" data-id="element-210" data-mp="148hsbucdg3zp">
              <path d={icon.path} data-id="element-211" data-mp="189jryca7ai27" />
            </svg>
          </a>
        </li>)}
    </ul>;
}